export default __webpack_public_path__ + "static/media/auhrct.4be0eb3f.png";